import React, { useEffect } from 'react';
import { pageTitle } from '../../helper';
import Cta from '../Cta';
import PageHeading from '../PageHeading';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import TeamSlider from '../Slider/TeamSlider';
import Spacing from '../Spacing';

export default function AboutPage() {
  pageTitle('About');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      {/* Start Page Heading Section */}
      <PageHeading
        title="About Us"
        bgSrc="images/about-hero.webp"
        pageLinkText="About Us"
      />
      {/* End Page Heading Section */}

      {/* Start About Section */}
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-xl-5 col-lg-7">
            <SectionHeading
              title="Your trusted partner for business"
              subtitle="About Our Company"
            >
              <Spacing lg="60" md="40" />
              <p className="cs-m0">
              At RLAB Group, we proudly stand as a woman-owned technology company committed to advancing women across the tech landscape. Under the leadership of our visionary founder and CEO Gul Azeem, we actively cultivate a diverse and inclusive environment where female technicians, engineers, and scientists thrive as valued leaders integral to our success. Gul herself passionately embodies our mission as a brand ambassador for Women in Tech, deeply believing in the power of empathy paired with technical expertise, and this driving ethos enables our team to deliver exceptional results. We form robust partnerships with trailblazing businesses of all kinds to help them achieve their digital goals and reach their full potential.
              <br /><br />
              At RLAB Group, we are committed to co-creating a future where all women can thrive as leaders shaping the digital landscape. Our team brings this vision to life each day through our client work, community building, and advocacy, and we're proud to be playing our part in driving the tech industry forward.
              </p>
              <Spacing lg="30" md="30" />
              <Div className="cs-separator cs-accent_bg"></Div>
              <Spacing lg="25" md="40" />
            </SectionHeading>
          </Div>
          <Div className="col-lg-5 offset-xl-2 d-flex justify-content-center align-items-center">
            <img
              src="/images/about_img_1.webp"
              alt="About"
              className="w-100 cs-radius_15"
            />
            <Spacing lg="25" md="25" />
          </Div>
          <Div className="col-lg-7">
            <img
              src="/images/about_img_2.webp"
              alt="About"
              className="w-100 cs-radius_15"
            />
            <Spacing lg="25" md="25" />
          </Div>
          <Div className="col-lg-5">
            <img
              src="/images/about_img_3.webp"
              alt="About"
              className="w-100 cs-radius_15"
            />
            <Spacing lg="25" md="25" />
          </Div>
        </Div>
      </Div>
      <Spacing lg="75" md="55" />
      {/* End About Section */}

      {/* Start Fun Fact Section */}
      {/* <Div className="container">
        <FunFact
          title="Our fun fact"
          subtitle="Sed ut perspiciatis unde omnis iste natus error voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis."
          data={funfaceData}
        />
      </Div> */ }
      {/* End Fun Fact Section */}

      {/* Start Why Choose Section */}
      <Spacing lg="100" md="80" />
      <Div className="container">
        <Div className="row d-flex flex-column flex-lg-row align-items-lg-center">
          <Div className="col-lg-6">
            <Div className="cs-image_layer cs-style1">
              <Div className="cs-image_layer_in">
                <img
                  src="/images/about_img_4.jpeg"
                  alt="About"
                  className="w-100 cs-radius_15"
                />
              </Div>
            </Div>
            <Spacing lg="0" md="40" />
          </Div>
          <Div className="col-lg-6">
            <SectionHeading
              title="Highly Experienced Team"
              subtitle="Why Choose Us"
            >
              <Spacing lg="30" md="20" />
              <p className="cs-m0">
                Our expertise runs deep, but it's how we put it to work that truly sets us apart. With decades of combined experience across AI, data science, and digital transformation, we've helped organizations from startups to Fortune 500 companies navigate complex technical challenges. We blend rigorous analysis with practical innovation, delivering solutions that drive real business growth.
              </p>
              <p className="cs-m0">
                What makes our approach unique? We don't just build technology—we build understanding. Our team takes the time to grasp your organization's specific challenges and opportunities, ensuring every solution is tailored to your needs. This collaborative approach, combined with our technical excellence, has led to lasting partnerships and measurable results for our clients.
              </p>
              <p className="cs-m0">
                When you work with RLAB Group, you gain more than a service provider. You get a partner invested in your success, backed by a proven track record of turning complex technical challenges into competitive advantages.
              </p>
              <Spacing lg="15" md="15" />
              <Spacing lg="30" md="30" />
              <Div className="cs-separator cs-accent_bg"></Div>
              <Spacing lg="25" md="0" />
            </SectionHeading>
          </Div>
        </Div>
      </Div>
      {/* End Why Choose Section */}

      {/* Start Team Section */}
      <Spacing lg="145" md="80" />
      <Div className="container">
        <SectionHeading
          title="Our Leadership Team"
          subtitle="Our Team"
          variant="cs-style1"
        />
        <Spacing lg="85" md="45" />
        <TeamSlider />
      </Div>
      {/* End Team Section */}

      {/* Start CTA Section */}
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Cta
          title="Lets collaborate to create something exceptional together."
          btnText="Apply For Meeting"
          btnLink="/contact"
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
      {/* End CTA Section */}
    </>
  );
}
